export default __webpack_public_path__ + "static/media/PASSWORD-DIGITAL- ACCOUNIS.b9e2fb0e.pdf";